import { render, staticRenderFns } from "./pcA.vue?vue&type=template&id=26ea09d3&scoped=true"
import script from "./pcA.vue?vue&type=script&lang=js"
export * from "./pcA.vue?vue&type=script&lang=js"
import style0 from "./pcA.vue?vue&type=style&index=0&id=26ea09d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ea09d3",
  null
  
)

export default component.exports